import React, { useEffect, useState } from "react";
import AddEditFormNotes from "./AddEditFormNotes";
import { axios } from "../../../../Global";
import { setAppError } from "../../../../store/userSlice";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import PromptElement from "../../PromptElement";
import ListDataNotes from "./ListDataNotes";
import { printValidationError } from "../../../../utils/functions";
import { checkAccessFn } from "../../../../utils/checkAccess";
import { getNotesData } from "../../../../store/Api";

export default function Notes(props) {
  const dispatch = useDispatch();
  const token = localStorage.getItem("token");
   const navigate = useNavigate();
  const [showPromptElement, setShowPromptElement] = useState({
    open: false,
    id: null,
  });
  const location = useLocation();
  const notesData = useSelector((state) => state.notesData);
  useEffect(() => {
   dispatch(getNotesData(token))
  },[])
 
  
  const [submitFormLoading, setSubmitFormLoading] = useState(false);
  const [loading, setLoading] = useState({
    edit: false,
    delete: false,
    listData: false,
    loadingId: "",
  });
  const [addOrEdit, setAddOrEdit] = useState({
    open: false,
    method: "",
    loadedValues: {},
    editId: "",
  });

  useEffect(() => {
    if (location.pathname.split("/")[3] === "create") {
      if(!checkAccess("Notes", "note-create")){
        setAddOrEdit({});
        navigate('/dashboard/notes')
      }else{
        setAddOrEdit((p) => ({ ...p, open: true, method: "add" }));
      }
    } else {
      setAddOrEdit((p) => ({ ...p, open: false }));
    }
  }, [location]);

  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [preName, setPreName] = useState("");
  const [preDescription, setPreDescription] = useState("");

  const submitForm = async (event) => {
    event.preventDefault();
    setSubmitFormLoading(true);
    try {
      let response;
      const body = {
        name,
        description,
      };
      if (addOrEdit.method === "add") {
        response = await axios.post(`/dashboard/note`, body, {
          headers: { Authorization: `Bearer ${token}` },
        });
      } else if (addOrEdit.method === "edit") {
        if(name===preName && description===preDescription) 
        {
          setSubmitFormLoading(false)
          return dispatch(setAppError({msg:'No changes made.'}))
        }
        response = await axios.put(
          `/dashboard/note/${addOrEdit.editId}`,
          body,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
      }
      const data = response.data.data;
      if (data) {
        dispatch(getNotesData(token))
        navigate("/dashboard/notes");
        dispatch(
          setAppError({
            msg: response.data.message,
            color: "bg-green-700",
          })
        );
        setSubmitFormLoading(false);
        setAddOrEdit((p) => ({ ...p, open: false }));
      }
    } catch (err) {
      printValidationError(err, "notes");
      setSubmitFormLoading(false);
      dispatch(
        setAppError({
          msg: err.message,
        })
      );
    }
  };
  const cancelForm = () => {
    navigate("/dashboard/notes");
    setAddOrEdit((p) => ({ ...p, open: false }));
  };
  const editData = async (id,data) => {
    navigate(`/dashboard/notes/edit-notes/${id}`);
    if (id) {
      setLoading((p) => ({ ...p, edit: true, loadingId: id }));
      try {
        await new Promise((resolve)=>setTimeout(resolve,300));
        setLoading((p) => ({ ...p, edit: false, loadingId: "" }));
        setAddOrEdit((p) => ({
          ...p,
          open: true,
          method: "edit",
          editId: id,
        }));
        setName(data.name);
        setDescription(data.description);
        setPreName(data.name);
        setPreDescription(data.description);
      } catch (err) {
        dispatch(
          setAppError({
            msg: err.message,
          })
        );
      }
    }
  };
  const deleteData = async (id) => {
    if (id) {
      setLoading((p) => ({ ...p, delete: true, loadingId: id }));
      try {
        const response = await axios.delete(`/dashboard/note/${id}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (response.status === 200) {
           dispatch(getNotesData(token));
          setLoading((p) => ({ ...p, delete: false, loadingId: "" }));
          dispatch(
            setAppError({
              msg: response.data.message,
              color: "bg-green-700",
            })
          );
        }
      } catch (err) {
        setLoading((p) => ({ ...p, delete: false }));
        dispatch(
          setAppError({
            msg: err.message,
          })
        );
        if (err?.response?.status === 403) {
          if (err?.response?.data?.message) {
            dispatch(
              setAppError({
                msg: err?.response?.data.message,
              })
            );
          }
        }
      }
    }
  };

  const addData = () => {
    setAddOrEdit((p) => ({ ...p, open: true, method: "add" }));
    setName("");
    setDescription("");
  };

  const dashboardData = useSelector((state) => state.dashboardData);
  const checkAccess = (module, name) =>  checkAccessFn(dashboardData, module, name);

  return (
    <>
      {showPromptElement.open && (
        <PromptElement
          showPromptElement={showPromptElement}
          setShowPromptElement={setShowPromptElement}
          deleteHandler={deleteData}
        />
      )}
      <div className={`p-2  sm:p-5 `}>
        {!addOrEdit.open && (
          <>
            {checkAccess("Notes", "note-create") &&
              <Link to="/dashboard/notes/create">
                <button
                  className="p-2 bg-red uppercase text-white rounded-md"
                  onClick={addData}
                >
                  Add New Note +
                </button>
              </Link>
          }

            <ListDataNotes
              list={notesData}
              editData={editData}
              deleteData={setShowPromptElement}
              loading={loading}
              column={4}
              titles={["SL No.", "Name", "Description", "Action"]}
            />
          </>
        )}
        {addOrEdit.open && (
          <AddEditFormNotes
            component="notes"
            form={[
              {
                type: "text",
                text: "Name",
                name: "name",
                value: name,
                update: setName,
                columnName: "name",
              },
              {
                type: "textarea",
                text: "Description",
                name: "description",
                value: description,
                update: setDescription,
                columnName: "description",
              },
            ]}
            submitForm={submitForm}
            cancelForm={cancelForm}
            submitFormLoading={submitFormLoading}
            loadedValues={addOrEdit.method === "edit" && addOrEdit.loadedValues ? true : false}
          />
        )}
      </div>
    </>
  );
}
